<template>
  <div class="json-viewer">
    <pre v-html="formattedJson"></pre>
  </div>
</template>

<script>
export default {
  name: 'JsonViewer',
  props: {
    json: {
      type: [Object, Array],
      required: true
    }
  },
  computed: {
    formattedJson() {
      return this.syntaxHighlight(this.json);
    }
  },
  methods: {
    syntaxHighlight(json) {
      if (typeof json != 'string') {
        json = JSON.stringify(json, null, 2);
      }
      json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(\.\d*)?([eE][+\-]?\d+)?)/g, match => {
        let cls = 'number';
        let style = 'color: #f8f8f2;';
        if (/^"/.test(match)) {
          cls = /:$/.test(match) ? 'key' : 'string';
          style = /:$/.test(match) ? 'color: #66d9ef;' : 'color: #f8f8f2;';
        } else if (/true|false/.test(match)) {
          cls = 'boolean';
          style = 'color: #fd971f;';
        } else if (/null/.test(match)) {
          cls = 'null';
        style = 'color: #f92672;';
        } else if (!isNaN(match)) {
          cls = 'number';
          style = 'color: #ae81ff;';
        }
        return `<span class="${cls}" style="${style}">${match}</span>`;
      });
    }
  }
};
</script>

<style scoped>
.json-viewer {
  background-color: #484B57;
  color: #f8f8f2;
  padding: 1em;
  border-radius: 5px;
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-word;
  height: 100%;
}

.key {
  color: #66d9ef !important;
}

.string {
  color: #a6e22e !important;
}

.number {
  color: #ae81ff !important;
}

.boolean {
  color: #fd971f !important;
}

.null {
  color: #f92672 !important;
}
</style>
